import React from 'react';
import Modal from 'react-responsive-modal';

import ApiResponse from './ApiResponse';
import {performApiRequest} from '../../util/restapi'; 

import iconSpinner from '../../assets/icons/spinner-snake.gif';

class ApiPerformingTaskMessage extends React.Component {

	response = null;
	doAfterClose = null;

	/*
		title
		message
		maxWidth
	*/
	constructor(props) {
		super(props);
		this.state = {
			isModalOpen: false,
			isModalActive: false,
		}
	}
	
	performTask = async (url, request, doAfterClose) => {
		this.response = null;
		this.doAfterClose = doAfterClose;
		this.setState({isModalOpen: true, isModalActive: true})
		this.response = await performApiRequest(url, request);
		if( this.response.success )
			this.closeModal();
		else
			this.setState({isModalActive: false})
	}
	closeModal = () => {
		if( this.doAfterClose != null ) {
			this.setState({ isModalOpen: false, isModalActive: false }, this.doAfterClose);
		} else {	
			this.setState({ isModalOpen: false, isModalActive: false });
		}
	}
	
	render() {
		var styleModal = {
			modal: {
				background: '#fff',
				padding: '0px',
				borderRadius: '21px',
				maxWidth: '600px',
				width: '100%',
			},
			closeButton: {
				top: '10px',
				right: '10px',
				fill: '#F00',
				outline: 'none',
			},
		};
		if( this.props.maxWidth )
			styleModal.modal.maxWidth = this.props.maxWidth;
		let stateHtml = null;
		if( ! this.state.isModalActive && this.response && ! this.response.success )
			stateHtml = <ApiResponse response={this.response} />
		else
			stateHtml = <div style={{textAlign: 'center', marginTop: '30px', marginBottom: '20px'}}><img src={iconSpinner} /></div>;
		return (
			<Modal open={this.state.isModalOpen} onClose={this.closeModal} center styles={styleModal} >
				<div style={{fontSize: '14pt', textAlign: 'center', padding: '10px', borderRadius: '21px 21px 0 0', backgroundColor: '#F0F0F0', }}>
					{this.props.title}
				</div>
				<div style={{marginTop: '20px', textAlign: 'center', fontSize: '16pt'}}>
					{this.props.message}
				</div>
				{stateHtml}
			</Modal>
		)
	}
}

export default ApiPerformingTaskMessage;